import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';

const faqData = [
  { q: 'Chi sono i Giovani Democratici?', a: "I Giovani Democratici sono l'organizzazione giovanile del Partito Democratico. Riuniscono giovani tra i 14 e i 30 anni impegnati nella politica e nella società civile." },
  { q: 'Come ci si iscrive?', a: 'Puoi iscriverti online dalla pagina Partecipa o recandoti presso il circolo GD più vicino a te. La tessera è gratuita per gli under 18.' },
  { q: 'Bisogna essere iscritti al PD?', a: "No, l'iscrizione ai Giovani Democratici è indipendente dall'iscrizione al Partito Democratico." },
  { q: 'Come trovo il circolo più vicino?', a: 'Visita la sezione Circoli del sito e usa la ricerca per città o regione per trovare il circolo più vicino a te.' },
  { q: 'Posso candidarmi a una carica interna?', a: 'Sì, tutti gli iscritti possono candidarsi alle cariche interne. Le modalità variano in base al livello (circolo, federazione, regionale, nazionale).' },
  { q: 'Come contattare la sede nazionale?', a: 'Puoi scriverci a info@giovanidemocratici.it o visitare la pagina Contatti per tutte le informazioni.' },
];

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'FAQ' }];

  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Supporto" title="Domande Frequenti" subtitle="Le risposte alle domande più comuni sui Giovani Democratici." />
      <section className="section"><div className="container" style={{ maxWidth: 800 }}>
        <div className="faq-list" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
          {faqData.map((faq, i) => (
            <div className={`faq-item card${openIndex === i ? ' is-open' : ''}`} key={i} style={{ padding: 0, overflow: 'hidden' }}>
              <button className="faq-item__question" onClick={() => setOpenIndex(openIndex === i ? null : i)} style={{ width: '100%', textAlign: 'left', padding: 'var(--space-5) var(--space-6)', background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'var(--weight-semibold)', fontSize: 'var(--text-body)', fontFamily: 'inherit', color: 'inherit' }}>
                <span>{faq.q}</span>
                <span style={{ fontSize: '1.25rem', transform: openIndex === i ? 'rotate(45deg)' : 'none', transition: 'transform 0.3s' }}>+</span>
              </button>
              {openIndex === i && (
                <div className="faq-item__answer" style={{ padding: '0 var(--space-6) var(--space-5)', color: 'var(--color-text-secondary)' }}>
                  <p>{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div></section>
    </Layout>
  );
};

export default FaqPage;
